export const SEARCH_PATH = '/sos/';
export const CART_PATH = '/sos/cart';
export const PRODUCTS_PATH = '/sos/products';
export const LOGIN_PATH = '/sos/login';
export const STORE_ID_SETTING_PATH = '/sos/storeid';
